/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Contact_Title_2Inputs */

const en_about_contact_title_2 = /** @type {(inputs: About_Contact_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your kind of work.`)
};

const lv_about_contact_title_2 = /** @type {(inputs: About_Contact_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`savu darbu.`)
};

/**
* | output |
* | --- |
* | "your kind of work." |
*
* @param {About_Contact_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_contact_title_2 = /** @type {((inputs?: About_Contact_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Contact_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_contact_title_2(inputs)
	return en_about_contact_title_2(inputs)
});